import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dddaa4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Kaerumedia" }
const _hoisted_2 = { class: "Kaerumedia-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "Kaerumedia-main viewport" }
const _hoisted_5 = { class: "Kaerumedia-main-list" }
const _hoisted_6 = { class: "Kaerumedia-main-recom" }

import { reactive, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Category from '@/components/bussiness/Category/Category.vue'
import NavBar from './components/NavBar.vue'
import ArticleList from './components/ArticleList.vue'
import HotArticlesList from './components/HotArticlesList.vue'
import ArticleDateFilter from './components/ArticleDateFilter.vue'
import { isD2C, useSite, isJA, isKO, isEN } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const jaBgD2c = require('@/assets/image/frag/frag-bg.jpg')
const jaBgB2b = require('@/assets/image/frag/frag-bg.jpg')
const koBgD2c = 'https://static-s.theckb.com/BusinessMarket/Client/frag/frag_bg_2c_ko.png'
const koBgB2b = 'https://static-s.theckb.com/BusinessMarket/Client/frag/frag_bg_2b_ko.png'
const enBgD2c = 'https://static-s.theckb.com/BusinessMarket/Client/frag-bg-d2c-en.png'
const enBgB2b = 'https://static-s.theckb.com/BusinessMarket/Client/frag-bg-b2b-en.png'
const route = useRoute()
const router = useRouter()
const imgSrc = computed(() => {
  return isJA() ? (isD2C() ? jaBgD2c : jaBgB2b)
    : isKO() ? (isD2C() ? koBgD2c : koBgB2b)
      : isEN() ? (isD2C() ? enBgD2c : enBgB2b) : ''
})
const navList = [
  {
    label: '全部',
    value: -1
  },
  {
    label: '采购相关',
    value: 1
  },
  {
    label: '物流相关',
    value: 2
  },
  {
    label: '优惠相关',
    value: 3
  },
  {
    label: 'OME相关',
    value: 4
  },
  {
    label: '他社合作相关',
    value: 5
  },
  {
    label: '其他',
    value: 0
  }
]

// 监听tab改变
watch(() => route.query.tab, (val) => {
  data.curType = parseInt(route.query.tab)
})

const data: any = reactive({
  // 当前选中的类目 对应navList -2为归档日期筛选
  curType: route.query.tab ? parseInt(route.query.tab) : -1,
  // 归档日期对象
  articleDateObj: {
    frogArticleYear: route.query.year,
    frogArticleMonth: route.query.month
  }
})

// data.curType = route.query.tab ? parseInt(route.query.tab) : -1

// 导航栏切换
const navChange = (index: number) => {
  // data.curType = index
  const query: any = {
    ...route.query
  }
  query.tab = index
  delete query.year
  delete query.month
  data.articleDateObj = {}
  router.replace({ ...route, query })
}

// 选中归档时间
const dateSelect = ({ frogArticleYear, frogArticleMonth }: {frogArticleYear: string, frogArticleMonth: string}) => {
  // data.curType = -2
  // data.articleDateObj = {
  //   frogArticleYear,
  //   frogArticleMonth
  // }
  changeDateFilter({ frogArticleYear, frogArticleMonth })
}

// 切换为归档文章
const changeDateFilter = ({ frogArticleYear, frogArticleMonth }: {frogArticleYear: string, frogArticleMonth: string}) => {
  const query: any = {
    ...route.query
  }
  query.tab = -2
  query.year = frogArticleYear
  query.month = frogArticleMonth
  router.replace({ ...route, query })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Category),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        referrerPolicy: "no-referrer",
        src: _unref(imgSrc),
        alt: "kaerumedia"
      }, null, 8, _hoisted_3)
    ]),
    _createVNode(NavBar, {
      navList: navList,
      index: _unref(data).curType,
      onChangeType: navChange
    }, null, 8, ["index"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ArticleList, {
          type: _unref(data).curType,
          dateObj: _unref(data).articleDateObj
        }, null, 8, ["type", "dateObj"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(HotArticlesList),
        _createVNode(ArticleDateFilter, {
          dateObj: _unref(data).articleDateObj,
          onSelect: dateSelect
        }, null, 8, ["dateObj"])
      ])
    ])
  ]))
}
}

})